import { useLocation } from 'react-router';
import { PageLayout } from './page/PageLayout';

export const ConnectToSfPage = () => {
  const { pathname } = useLocation();
  return <PageLayout withConnectToSfButtons pathname={pathname} />;
};
